import { render, staticRenderFns } from "./UiPopup.vue?vue&type=template&id=2acca538&scoped=true"
import script from "./UiPopup.vue?vue&type=script&lang=js"
export * from "./UiPopup.vue?vue&type=script&lang=js"
import style0 from "./UiPopup.vue?vue&type=style&index=0&id=2acca538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acca538",
  null
  
)

export default component.exports